import { useController } from '@framework/form/hooks/useController.ts';
import { CheckboxInput } from '@framework/form/inputs/CheckboxInput.tsx';
import { MenuPresets } from '@framework/form/inputs/rich-text/menu/MenuPresets.tsx';
import { TextInput } from '@framework/form/inputs/TextInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { RowElement } from '@framework/ui/components/row/RowElement.tsx';
import { RichTextAdvancedInput } from '../../../../../inputs/rich-text-advanced/RichTextAdvancedInput.tsx';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { CodeLabelInputForm } from '../../inputs/common/CodeLabelInputForm.tsx';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps.ts';
import { type IRepeatableWidget } from './IRepeatableWidget.ts';

export interface IRepeatableWidgetConfigComponentProps
  extends IWidgetComponentProps<IRepeatableWidget> {}

export function RepeatableWidgetConfigComponent(
  props: IRepeatableWidgetConfigComponentProps,
) {
  const options = getWidgetProps(props);
  const { field: hideAddButtonField } = useController('layout.hideAddButton');
  const { field: hideRemoveButtonField } = useController(
    'layout.hideRemoveButton',
  );
  const { field: showConfirmDeleteField } = useController(
    'layout.showConfirmDelete',
  );

  return (
    <>
      {/* La label resta dichiarata qui: usa l'editor Inline a 4 righe */}
      <CodeLabelInputForm widgetOptions={options} hideLabel />

      {/* <DefaultValueInput /> */}

      <FormItem name="label" label="Etichetta">
        <RichTextAdvancedInput
          name="label"
          menus={MenuPresets.Inline}
          rows={4}
        />
      </FormItem>

      <FormItem name="description" label="Descrizione">
        <RichTextAdvancedInput
          name="description"
          menus={MenuPresets.Block}
          rows={4}
        />
      </FormItem>

      <RowElement>
        <FormItem
          name="layout.buttonText"
          label="Testo del Pulsante Aggiungi"
          help="Valore di default 'Aggiungi'"
        >
          <TextInput
            name="layout.buttonText"
            disabled={hideAddButtonField.value}
          />
        </FormItem>

        <FormItem
          name="layout.hideAddButton"
          label="Impostazione visibilità pulsante"
        >
          <CheckboxInput name="layout.hideAddButton" defaultChecked={false}>
            Nascondi pulsante Aggiungi
          </CheckboxInput>
        </FormItem>
      </RowElement>

      <RowElement>
        <FormItem
          name="layout.hideNumberItem"
          label="Impostazione visibilità numerazione"
        >
          <CheckboxInput name="layout.hideNumberItem" defaultChecked={false}>
            Nascondi numero della lista
          </CheckboxInput>
        </FormItem>
        <FormItem
          name="layout.hideBorder"
          label="Impostazione visibilità bordo"
        >
          <CheckboxInput name="layout.hideBorder" defaultChecked={false}>
            Nascondi bordo
          </CheckboxInput>
        </FormItem>
      </RowElement>

      <RowElement>
        <FormItem
          name="layout.showAtLeastOne"
          label="Mostra inizialmente almeno un elemento"
          help="La lista mostrerà inizialmente almeno un elemento vuoto (da compilare) all'utente."
        >
          <CheckboxInput name="layout.showAtLeastOne" defaultChecked={false}>
            Mostra inizialmente almeno un elemento
          </CheckboxInput>
        </FormItem>
      </RowElement>

      <RowElement>
        <FormItem
          name="layout.hideRemoveButton"
          label="Nascondi visibilità pulsante"
        >
          <CheckboxInput name="layout.hideRemoveButton" defaultChecked={false}>
            Nascondi pulsante Rimuovi
          </CheckboxInput>
        </FormItem>
      </RowElement>

      {!hideRemoveButtonField.value && (
        <>
          <RowElement>
            <FormItem
              name="layout.showConfirmDelete"
              label="Mostra conferma eliminazione"
              help="Mostra un messaggio di conferma all'utente prima di eliminare un elemento."
            >
              <CheckboxInput
                name="layout.showConfirmDelete"
                defaultChecked={false}
              >
                Mostra conferma eliminazione
              </CheckboxInput>
            </FormItem>
          </RowElement>
          {showConfirmDeleteField.value && (
            <>
              <FormItem
                name="layout.confirmDeleteTitle"
                label="Testo del messaggio di conferma eliminazione"
                help="Testo del messaggio di conferma mostrato all'utente prima di eliminare un elemento."
              >
                <TextInput name="layout.confirmDeleteTitle" />
              </FormItem>
              <RowElement>
                <FormItem
                  name="layout.confirmDeleteButtonLabel"
                  label="Testo del pulsante di conferma eliminazione"
                  help="Testo del pulsante di conferma mostrato all'utente prima di eliminare un elemento."
                >
                  <TextInput name="layout.confirmDeleteButtonLabel" />
                </FormItem>
                <FormItem
                  name="layout.cancelDeleteButtonLabel"
                  label="Testo del pulsante di annulla eliminazione"
                  help="Testo del pulsante di annulla mostrato all'utente prima di eliminare un elemento."
                >
                  <TextInput name="layout.cancelDeleteButtonLabel" />
                </FormItem>
              </RowElement>
            </>
          )}
        </>
      )}
      {/* Futura card "Riepilogo":
          <RepeatableConfigSummaryInput widget={props.widget} /> */}
    </>
  );
}
